import { WxNews, WxImage, WxText, WxCard } from '@/customer/models/CustomerMsg';
import News from '@/mass/models/News';
import FormatEmoji from '@/common/utils/FormatEmoji';
import { PropConfig } from '@/customer/models/PropConfig';

export interface ScheduleMsg {
  WxTpl?: WxTpl;
  WxNews?: WxNews;
  WxImage?: WxImage;
  WxText?: WxText;
  WxCard?: WxCard;
  WxSubTpl?: WxSubTpl;
}

export interface WxSubTpl {
  title: string;
  templateId: string;
  params: { [key: string]: ScheduleMsgParam } ;
  unsubNotify: ScheduleMsgUnsubNotify;
  url?: string;
  mini?: ScheduleMsgMini;
  coupon?: ScheduleMsgCoupon;
  remark?: ScheduleMsgRemarkSet;
}

export interface ScheduleMsgDisplayInfo {
  cardInfo: any | undefined;
}

export const Factory = {
  fromText(text: string): ScheduleMsg {
    return {
      WxText: {
        text,
      },
    }
  },
  fromNews(news: News, children: Array<News>): ScheduleMsg {
    children.unshift(news);
    return {
      WxNews: {
        newsId: news.id,
        allowReprint: true,
        isToAll: false,
        openComment: false,
        snapshot: children,
      },
    }
  },
  fromImage(mediaId: string, src: string) {
    return {
      WxImage: {
        media: mediaId,
        src,
      },
    }
  },
  fromWxCard(cardId: string ) {
    return {
      WxCard: {
        cardId,
      },
    }
  },
  fromCardLink(cardText: string ) {
    return {
      WxCard: {
        cardText,
      },
    }
  },
}

export interface WxTpl {
  templateId: string;
  params: { [key: string]: ScheduleMsgParam } ;
  unsubNotify: ScheduleMsgUnsubNotify;
  url?: string;
  mini?: ScheduleMsgMini;
  coupon?: ScheduleMsgCoupon;
  remark?: ScheduleMsgRemarkSet;
}
export interface ScheduleMsgParam {
  color?: string;
  value: string;
}
export interface ScheduleMsgUnsubNotify {
  enabled: boolean;
  replyText?: string;
}
export interface ScheduleMsgMini {
  appid: string;
  pagepath: string;
}
export interface ScheduleMsgCoupon {
  id: string;
  cardId: string;
  color: string;
  title: string;
  brandName: string;
  logoUrl: string;
}
export interface ScheduleMsgRemarkSet {
  open: boolean;
  remark: string;
  code: string;
}

export function transDiv(value: string) {
  value = value.replace(new RegExp('<div><br></div>', 'g'), '<br>');
  value = value.replace(new RegExp('</div>', 'g'), '');
  value = value.replace(new RegExp('<div>', 'g'), '<br>');
  value = value.replace(/^(<\s*br\s*\/?>)*/g, '')
  return value;
}

export function textToHtml(text: string, props?: Array<PropConfig>) {
  let html = FormatEmoji.toEmoji(text);
  (props || []).forEach((p: any) => {
    html = html.replace(new RegExp(p.fieldName, 'g'), '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>');
    html = html.replace(new RegExp('\\${custom.current}', 'g'), '<drip-prop contenteditable="false">#当前时间</drip-prop>');
  });
  return html;
}

export function transValue(props: any, value: string) {
  props.forEach((p: any) => {
    if (p.builtIn) {
      value = value.replace(new RegExp(p.propName, 'g'), '${' + p.fieldName + '}');
    } else {
      value = value.replace(new RegExp(p.propName, 'g'), '${privateProps.' + p.fieldName + '}');
    }
    value = value.replace(new RegExp('<drip-prop contenteditable="false">#系统时间</drip-prop>', 'g'), '${custom.current}');
  });
  value = value.replace(new RegExp('<drip-prop contenteditable="false">.*</drip-prop>', 'g'), '');
  return value;
}
